import type { EntryPoint } from '@ipfabric/utils';

export type EntryPointValue = {
  host: Pick<EntryPoint, 'sn' | 'hostname'> | null;
  iface: EntryPoint['iface'] | null;
};

export const entryPointValuesToEntryPoints = (
  values: EntryPointValue[],
): EntryPoint[] =>
  values.reduce<EntryPoint[]>((acc, value) => {
    if (value.host !== null && value.iface !== null) {
      acc.push({
        hostname: value.host.hostname,
        sn: value.host.sn,
        iface: value.iface,
      });
    }
    return acc;
  }, []);

export const entryPontsToEntryPointValues = (
  entryPoints: EntryPoint[],
): EntryPointValue[] =>
  entryPoints.map((entryPoint) => ({
    host: {
      hostname: entryPoint.hostname,
      sn: entryPoint.sn,
    },
    iface: entryPoint.iface,
  }));
